import './SitemapLinksSkeleton.scss';

const SitemapLinksSkeleton = () => {

    const skeletonBlocks = [11, 6, 10, 12, 7];

    return (
        <div className="sitemap__links__wrapper__skeleton">
            {skeletonBlocks.map((itemCount, blockIndex) => (
                <div key={blockIndex} className="sitemap__block__skeleton">
                    <div className="sitemap__block__title__skeleton"></div>
                    {[...Array(itemCount)].map((_, index) => (
                        <div key={index} className="sitemap__block__list__skeleton"></div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default SitemapLinksSkeleton;